<template>
    <div class="action">
        <div class="action__title" v-if="config.id !== 3">{{ data.title }}</div>
        <div class="action__timer">
            <ui-circle-timer :value="timeWait">{{ secStr }}</ui-circle-timer>
        </div>

        <div v-if="data.type === 'quiz'" class="action-quiz">
            <div class="action-quiz__title">{{ data.action.title }}</div>
            <div class="action__body">
                <div class="action-quiz__img action__good">
                    <block-good-img class="action__good-img" :class="`action__good-img--id-${region.goodId}`" :id="region.goodId" />
                </div>
                <div class="action__description">
                    «{{ data.action.description }}»
                </div>
            </div>
            <div></div>
            <ul class="action-quiz__actions" :class="{'action-quiz__actions--list': config.id === 4}">
                <li v-for="(answer, i) in data.action.answers" :key="i">
                    <button class="action__btn action-quiz__btn ui-btn" @click="selectAnswer(answer)">
                        {{ answer.title }}
                    </button>
                </li>
            </ul>
        </div>

        <div v-else-if="data.type === 'click'">
            <div class="action-click">
                <div class="action__body">
                    <div class="action__good">
                        <block-good-img :id="region.goodId" />
                    </div>
                    <div class="action__description action-click__description">
                        {{ data.action.title }}
                    </div>
                </div>
            </div>
            <div>{{ data.action.description }}</div>
            <div class="action-click__btns">
                <button class="ui-btn action__btn" @click="submit">Да</button>
                <button class="ui-btn action__btn" @click="submit">Нет</button>
            </div>
        </div>

        <div v-else-if="data.type === 'review'">
            <div class="action-review">
                <div class="action-review__title">{{ data.title }}</div>
                <button class="ui-btn action__btn" @click="submit">Попросить</button>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'

    export default {
        components: {},
        props: {
            id: {
                type: String,
                required: true
            },
            config: {
                type: Object,
                required: true
            },
            data: {
                type: Object,
                required: true
            },
            regionId: {
                type: Number,
                required: true
            }
        },
        data () {
            return {
                timeout: null,
                wait: 0,
                timeWait: 0
            }
        },
        computed: {
            ...mapGetters('regions', ['regionById']),

            region () {
                return this.regionById(this.regionId)
            },

            sec () {
                return this.wait / 1000
            },

            secStr () {
                return ('0' + Math.ceil(this.sec)).slice(-2)
            }
        },
        methods: {
            ...mapActions('control', ['start', 'pause']),
            checkTimeout () {
                if (this.wait > 0) {
                    this.wait -= 200
                    this.timeout = setTimeout(() => this.checkTimeout(), 200)
                } else {
                    this.wait = 0
                    this.cancel()
                }
            },
            init () {
                this.pause()
                this.timeWait = this.config.time * 1000
                this.wait = this.timeWait
                this.timeout = setTimeout(() => this.checkTimeout(), 200)
            },
            close () {
                clearTimeout(this.timeout)
                this.$store.dispatch('actions/removeAction', this.id)
                this.$emit('close')
                this.start()
            },
            cancel () {
                this.incorrect()
                this.close()
            },
            selectAnswer (answer) {
                if (answer.right) {
                    this.correct(answer.reward)
                } else {
                    this.incorrect(answer.reward)
                }
                this.close()
            },
            submit () {
                this.correct()
                this.close()
            },
            correct (reward) {
                const value = reward || this.config.right
                this.$store.dispatch('history/push', {message: `Action correct +${value}balls`, theme: 'success'})
                this.$store.dispatch('balance/add', value)
            },
            incorrect (reward) {
                const value = reward || this.config.lose
                this.$store.dispatch('history/push', {message: `Action incorrect -${value}balls`, theme: 'warn'})
                this.$store.dispatch('balance/remove', value)
            }
        },
        mounted () {
            this.init()
        }
    }
</script>

<style lang="stylus" scoped>
    .action {
        font-size 14px
        position relative

        &__title {
            font-size 1.5rem
            line-height 2.4rem
            margin-bottom 0.6rem
            max-width 80%
            +layout-sm() {
                max-width 60%
            }
            +layout-xs() {
                line-height 2rem
            }
        }

        &__body {
            display flex
            align-items flex-start
            margin-bottom 2.2rem
        }

        &__good {
            width 8.5rem
            height 8.5rem
            border-radius 50%
            overflow hidden
            background-color #3665F3
            margin-right 2rem

            &-img {
                position relative
                width 100%
                height 100%
                max-width 100%
            }

            &-img--id-1 {
                right -1rem
                bottom -1.3rem
            }

            &-img--id-2 {
                width 73%
                right -1.4rem
                bottom -1.5rem
            }

            &-img--id-3 {
                width 61%
                right -1.9rem
                bottom -1.2rem
            }

            &-img--id-4 {
                width 88%
                right -0.7rem
                bottom -1.2rem
            }

            &-img--id-5 {
                width 73%
                right -1.2rem
                bottom -1.2rem
            }

            &-img--id-6 {
                width 85%
                right -0.7rem
                bottom -1.8rem
            }

            &-img--id-7 {
                width 83%
                right -0.6rem
                bottom -1.2rem
            }
        }

        &__description {
            align-self stretch
            display flex
            align-items center
            font-size 1.5rem
            line-height 2.4rem
            color #2B0EAF
            font-style italic
            flex 1 1
            +layout-sm() {
                line-height 2rem
            }
        }

        &__timer {
            position absolute
            top 0
            right 0
            color #121258
            font-size 2rem
            font-weight $font-bold
            +layout-xs() {
                transform scale(0.75)
                right -0.4rem
            }
        }

        &__btn {
            font-size 1.5rem
            line-height 1.8rem
            width 22rem
            background-color #121258
            color #C5E5FB
            padding 1.5rem
            min-height 4.8rem
            +layout-xxs() {
               width 100%
            }
        }
    }

    .action-quiz {
        max-width 45rem
        &__title {
            font-size 2rem
            line-height 2.4rem
            margin-bottom 2rem
            font-weight $font-bold
            +layout-sm() {

                font-size 2rem
                margin-bottom 2rem
            }
        }
        &__img {
            +layout-xs() {
                display none
            }
        }

        &__actions {
            list-style none
            padding 0
            margin 0
            display grid
            grid-template-columns 1fr 1fr
            grid-gap 1.1rem 1.5rem
            +layout-xs() {
                grid-gap 0.5rem 1.5rem
                grid-template-columns 1fr
            }

            &--list {
                grid-template-columns 1fr
                grid-gap 0.5rem 0

                .ui-btn {
                    text-align left
                }
            }
        }

        &__btn {
            background-color #C4E5FC
            width 100%
            color #121258
        }
    }

    .action-click {
        max-width 45rem

        &__btns {
            display grid
            grid-template-columns 1fr 1fr
            grid-gap 1rem 1rem
            +layout-sm() {
                grid-template-columns 1fr
                .ui-btn {
                    width 100%
                }
            }
        }

        .action__body {
            +layout-xs() {
                display flex
            flex-direction column
            }
        }

        .action__good {
            +layout-xs() {
                margin-right 0
                margin-top 1.5rem
                width 100%
                height 100px
                border-radius 0
                padding-top 1rem
            }
        }
        img {
            display block
            margin 0 auto
            max-height 100%
        }
        &__description {
            font-size 2rem
            line-height 2.8rem
            +layout-xs() {
                margin-top: 1.5rem
            }
        }
    }


    .action-review {
        width 100%
        max-width 30rem

        &__title {
            font-size 2rem
            line-height 2.6rem
            margin-bottom 1.5rem
            margin-right 5.5rem
            color #2B0EAF
            +layout-xs() {
                line-height 2.5rem
            }
        }
    }
</style>
